import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import ContactDialog from "@/components/ContactDialog";

const LearningCircleSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-foreground">
            Nurturing the Learning Ecosystem
          </h2>
          
          {/* Centered Quote */}
          <div className="max-w-5xl mx-auto text-center mb-16">
            <blockquote className="text-lg md:text-xl leading-relaxed italic text-foreground/90 mb-6">
              "We, Faizan, Rani, and Amrut, began our engineering journey at KLE Technological University, Hubballi, Karnataka, driven by a passion for robotics and automation. Our path led us to Vegam, where we are exposed to industry challenges and building real-world robotics and automation systems. 
              <br /><br />
              With the guidance we received from our mentors and technology experts, we developed not only technical skills but also a mindset of continuous learning. Today, we wish to share our experience and foster a culture of continuous learning by working closely with educators and the student community."
            </blockquote>
            <cite className="text-base font-bold text-foreground">- Faizan, Rani & Amrut</cite>
          </div>
          
          {/* Two Cards Side by Side */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* Card 1: ConnectNext Program */}
            <Card className="h-full shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardContent className="p-8 h-full flex flex-col">
                <h3 className="text-2xl font-bold mb-6 text-primary">
                  ConnectNext Program
                </h3>
                <p className="text-foreground/80 leading-relaxed flex-grow">
                  We are proud to contribute voluntarily as <b>Industry Mentors</b> for the <b>ConnectNext Program</b> by <b>La Fondation Dassault Systèmes.</b> In this program, we, as subject-matter experts in the field of robotics, define real-world problem statements in robotics and automation and mentor the budding innovators/ technocrats/ engineers, preparing them for <b>smart manufacturing</b> and <b>industry challenges.</b>
                </p>
                <div className="mt-6">
                  <Button 
                    asChild 
                    className="w-full md:w-auto"
                  >
                    <a 
                      href="https://www.lafondation3ds.org/projects/connectnext-students-be-industry-ready/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      Know More about ConnectNext Program
                    </a>
                  </Button>
                </div>
              </CardContent>
            </Card>
            
            {/* Card 2: Calling the Student Community */}
            <Card className="h-full shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardContent className="p-8 h-full flex flex-col">
                <h3 className="text-2xl font-bold mb-6 text-primary">
                  Mentorship & Collaboration
                </h3>
                <p className="text-foreground/80 leading-relaxed flex-grow">
                  Beyond structured programs, we welcome students and educators with a passion for technology and robotics. Whether it’s guidance on real-world projects, automation solutions, or cross-disciplinary innovation, we aim to help curious minds transform ideas into practical, efficient, and sustainable solutions.
                  <br /><b>Engineering isn’t just about solving today’s challenges, it’s about imagining a better tomorrow.</b>
                </p>
              </CardContent>
            </Card>
          </div>
          
          {/* CTA Button */}
          <div className="text-center">
            <ContactDialog>
              <Button
                size="lg"
                className="text-lg px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
                aria-label="Open contact form"
              >
                Let's Collaborate
              </Button>
            </ContactDialog>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LearningCircleSection;
